module.exports = "/_next/static/images/terrace-57fe321fcd3badb80786b598847f0949.jpg";